import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceCommissionById, setFinanceCommissionStatus } from '@/api/financial-center'
import {getMessageRemindById, getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'

@Component({})
export default class BackMoneyParnterInfo extends Vue {
    logShow = true
    backMoneyInfo: any = ''
    financeBackMoneyDetailList = []
    status: number = null
    approval_id: number = null // 审批查看详情id
    approval_type: string = null //审批状态 type 0-审批，1-查看
    reviewStatus: string
    opinion = '' // 审批意见
    cancleReview = false
    reviewDialog = false
    fileList = []
    fileList1 = []
    turnParagraphArr = []
    moneyCertificatesArr = []
    addDataList: any

    editFileList = []
    editFiles = {
        // isBackStudentContract: null,
        isBackAgentContract: null,
        financeCommissionProofList: null,
    }
    isRequired = true
    editFileRequired = false
    previewVisible = false
    previewPath = []
    buttonDisabled = false
    types = ''
    financeCommissionAccount= {}
    accountType = ''
    loading = false
    activities = []

    get elImageUrls() {
        return this.turnParagraphArr ? this.turnParagraphArr.map(item => item.url) : []
    }

    get orderAllPrice() {
        let num = 0
        if(this.backMoneyInfo.financeCommissionDetailList){
            this.backMoneyInfo.financeCommissionDetailList.map(item => num += Number(item.priceSum))
        }
        return num
    }


    get turnParagraphUrl() {//转款
        return this.turnParagraphArr.map(item => item.url)
    }
    get moneyCertificatesUrl() {//打款
        return this.moneyCertificatesArr.map(item => item.url)
    }

    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)
    }

    formatDate = formatDate

    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }

    async getMsgData(id) {
        this.loading = true
        await getMessageRemindById({id: id}).then((data: any)=>{


        this.backMoneyInfo = data.result.messageRemindInfo
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.approval_type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.backMoneyInfo.financeCommissionProofList.map(item => {
            // 转款凭证
            if(item.types == '1'){
                this.turnParagraphArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
            // 打款凭证
            if(item.types == '0'){
                this.moneyCertificatesArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
        })
        this.editFileList = data.result.messageRemindInfo.editFileList || []
        this.editFileList.forEach(item => {
            this.editFiles[item.file] = data.result.messageRemindInfo[item.file]
        })
        this.financeCommissionAccount = this.backMoneyInfo.financeCommissionAccount
        this.accountType = (this.financeCommissionAccount as any).type;
        this.activities = data.result.messageRemindInfo.messageReviewList
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })
    }

    async getMessageReviewById() {
        const data: any = await getMessageReviewById(this.approval_id,this.types)
        this.editFileList = data.result.editFileList || []
        this.editFileList.forEach(item => {
            this.editFiles[item.file] = data.result[item.file]
        })
        this.backMoneyInfo = data.result
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.approval_type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.backMoneyInfo.financeCommissionProofList.map(item => {
            // 转款凭证
            if(item.types == '1'){
                this.turnParagraphArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
            // 打款凭证
            if(item.types == '0'){
                this.moneyCertificatesArr.push({
                    name:item.name,
                    types:item.types,
                    url:item.url,
                })
            }
        })
    }
    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.approval_type !== '0') return false
        return this.editFileList.some(item => item.cnFile === key)
    }
    // 撤回审批cancleReview
    async cancleReviewDialogConfirm() {
        await setFinanceCommissionStatus({ id: Number(this.backMoneyInfo.id), action: '1' })
        this.$message.success('成功撤回审批')
        setTimeout(() => { window.close() }, 1500)
    }
    // 通过
    // 1通过 2驳回
    openReviewDialog(status: number) {
        if(this.backMoneyInfo.directorDepartmentlName == '财务部'){
            if(this.fileList.length === 0) { this.$message.error('财务请上传打款凭证'); return }
        }
        this.status = status
        this.reviewDialog = true
    }
    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }
    reviewDialogConfirm() {
        const newObj = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
        }
        if(this.isRequired) {
            let bol = false
            for(const key in newObj) {
                if(['', null, undefined].includes(newObj[key])) {
                    bol = true
                    break;
                } else {
                    bol = false
                }
            }
            if(bol) {
                this.$message.error('请将编辑信息填写完整')
                return
            }
        }
        newObj.financeCommissionProofList = [...this.moneyCertificatesArr, ...this.turnParagraphArr]
        const obj = {
            messageReviewId: this.approval_id,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {}
        }

        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        this.buttonDisabled = true
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(`审批${this.status === 1 ? '通过' : '驳回'}`)
            setTimeout(() => {
                window.close()
            }, 1500)
            this.buttonDisabled = false
        }).catch((err: Error) => {
            console.log(err)
            this.buttonDisabled = false
        })
    }

    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.moneyCertificatesArr.push({ name: data.name, url: data.ossUrl, types: '0' })
    }
    uploadSuccess1(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.turnParagraphArr.push({ name: data.name, url: data.ossUrl, types: '1'  })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    uploadError1() {
        this.$message.error('上传失败')
    }
    handlePreview(file) {
        this.previewPath = [file.url]
        this.previewVisible = true
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }
    handleUploadRemove1(file) {
        this.fileList1 = this.fileList1.filter(item => item.uid !== file.uid)
    }

    previewContractUrl() {
        window.open(this.backMoneyInfo.financeContractUrl, 'blank')
    }
}
